import { IncidentDetailsTechniquesSectionWebComponent } from './component/IncidentDetailsTechniquesSectionWebComponent';

export { IncidentDetailsTechniquesSectionWebComponent };
